// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"7418":"settings-apps-view","8351":"settings-users"}[chunkId] + "-" + chunkId + ".js?v=" + {"7418":"6b12629ae9c49b94ff47","8351":"42aa7b95279d8b9c5b3d"}[chunkId] + "";
};